import axios from 'axios';
import { push, replace } from 'react-router-redux';
import * as Msal from '@azure/msal-browser';
import {JWTOKEN, STAFFID, STDBIDSESSION_ID, CATEGORY_ID, ACCESS_TOKEN, STATION_ID} from './../constants';
import * as actionTypes from './actionTypes';
import apiCall from './../app/apiCall.js';
import { loginRequest, msalConfig } from '../../authConfig';
import { apiUrl, home, login } from './../../settings/settings';
import { string } from 'prop-types';

let errors;
let commonLabels;

if (sessionStorage.getItem('lng') === 'fr') {
  errors = require('./../../labels/labels.french.json').errors;
  commonLabels = require('./../../labels/labels.french.json').commonLabels;
} else {
  errors = require('./../../labels/labels.json').errors;
  commonLabels = require('./../../labels/labels.json').commonLabels;
}

const loadAndUpdateLastUseUrl = "employees/loadAndUpdateLastUse";

export const fetchLoginRequest = () => ({
  type: actionTypes.FETCH_LOGIN_REQUEST
});
export const fetchLoginFailure = message => ({
  type: actionTypes.FETCH_LOGIN_FAILURE,
  message
});
export const fetchLoginSuccess = login => ({
  type: actionTypes.FETCH_LOGIN_SUCCESS,
  login
});
export const userLogout = () => ({ type: actionTypes.USER_LOGOUT });

export function redirect(path) {
  return (dispatch) => {
    dispatch(push(path));
  };
}

export function logout(path) {
  return (dispatch) => {
    // Preserve language preference across logout
    const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
    dispatch(replace(path));
    dispatch(userLogout());
    sessionStorage.removeItem('jwToken');
    sessionStorage.removeItem(STAFFID);
    sessionStorage.removeItem('standingBidSessionId');
    sessionStorage.removeItem('categoryId');
    // Restore language preference after clearing session
    if (tempLng) {
      localStorage.setItem('lng', tempLng);
      sessionStorage.setItem('lng', tempLng);
    }
    window.location.reload();
  };
}

export function expireSession() {
  return logout('/login');
}

export function fetchLogin(username, password) {
  return (dispatch) => {
    function getUserData(jwToken, staffId) {
      const userRequestUrl = `${loadAndUpdateLastUseUrl}/${staffId}`;
      apiCall(userRequestUrl, "put").then((data) => {
        if (staffId === commonLabels.ADMIN) {
          const user = data.data;

          sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
          sessionStorage.setItem(CATEGORY_ID, '');
          dispatch(push(home.homePageUrl));
          return dispatch(fetchLoginSuccess({ jwToken, user }));
        }
        const user = data.data;
        sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
        sessionStorage.setItem(
            CATEGORY_ID,
            user.currentCategory.categoryId || null
          );
        dispatch(push(home.homePageUrl));
        return dispatch(fetchLoginSuccess({ jwToken, user }));
      }).catch((error) => {
        let errorToDisplay = '';
        if (error.response) {
          errorToDisplay = errors.LOGIN_401;
        } else {
          errorToDisplay = errors.LOGIN_FAILURE;
        }
        dispatch(fetchLoginFailure(errorToDisplay));
      });
    }
    dispatch(fetchLoginRequest());
    return axios({
      method: 'post',
      url: `${apiUrl}/auth/login`,
      data: {
        username,
        password
      }
    })
      .then((response) => {
        const jwToken = response.data;
        sessionStorage.setItem(JWTOKEN, JSON.stringify(jwToken));
        sessionStorage.setItem(STAFFID, username);
        getUserData(jwToken, username);
      })
      .catch((error) => {
        let errorToDisplay = '';
        if (error.response) {
          errorToDisplay = errors.LOGIN_401;
        } else {
          errorToDisplay = errors.LOGIN_FAILURE;
        }
        dispatch(fetchLoginFailure(errorToDisplay));
      });
  };
}

export function getUserInformation(staffId) {
  return () => {
    const userRequestUrl = `employees/${staffId}`;
    return apiCall(userRequestUrl);
  };
}

export function fetchLoginMsal() {
  return (dispatch) => {
    function getUserData(jwToken, staffId) {
      const userRequestUrl = `${loadAndUpdateLastUseUrl}/${staffId}`;
      apiCall(userRequestUrl, 'put', {}, null, 'text/plain').then((data) => {
        if (data && data.data) {
          const user = data.data;
          sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
          sessionStorage.setItem(
              CATEGORY_ID,
              user.currentCategory.categoryId || null
            );
          sessionStorage.setItem(
              'chk',
              JSON.stringify(user.loadStanding) || null
            );
          dispatch(push(home.homePageUrl));
          return dispatch(fetchLoginSuccess({ jwToken, user }));
        }
      }).catch((error) => {
        let errorToDisplay = '';
        if (error.response) {
          errorToDisplay = errors.LOGIN_401;
        } else {
          errorToDisplay = errors.LOGIN_FAILURE;
        }
        dispatch(fetchLoginFailure(errorToDisplay));
      });
    }

    dispatch(fetchLoginRequest());
    const existingToken = JSON.parse(sessionStorage.getItem(JWTOKEN));
    const existingStaffId = sessionStorage.getItem(STAFFID);
    getUserData(existingToken, existingStaffId);
  };
}

export function fetchLoginOIDC() {
  return (dispatch) => {
    function getUserData(accessToken, staffId) {
      const userRequestUrl = `${loadAndUpdateLastUseUrl}/${staffId}`;
      apiCall(userRequestUrl, 'put', {}, null, 'text/plain').then((data) => {
        if (data && data.data) {
          const user = data.data;
          sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
          sessionStorage.setItem(
            CATEGORY_ID,
            user.currentCategory?.categoryId || null
          );
          sessionStorage.setItem(
            'chk',
            JSON.stringify(user.loadStanding) || null
          );
          sessionStorage.setItem(
            STATION_ID,
            user.currentCategory?.stationId || null
          );
          dispatch(push(home.homePageUrl));
          return dispatch(fetchLoginSuccess({ jwToken: accessToken, user }));
        }
        return dispatch(fetchLoginFailure(errors.LOGIN_FAILURE));
      }).catch(() => {
        dispatch(fetchLoginFailure(errors.LOGIN_FAILURE));
      });
    }

    dispatch(fetchLoginRequest());
    const existingStaffId = sessionStorage.getItem(STAFFID);
    getUserData(false, existingStaffId);
  };
}

export function fetchLoginSSO() {
  return (dispatch) => {
    function getUserData(jwToken, staffId) {
      const userRequestUrl = `${loadAndUpdateLastUseUrl}/${staffId}`;
      apiCall(userRequestUrl, "put").then((data) => {
        if (staffId === commonLabels.ADMIN) {
          const user = data.data;
          sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
          sessionStorage.setItem(CATEGORY_ID, '');
          dispatch(push(home.homePageUrl));
          return dispatch(fetchLoginSuccess({ jwToken, user }));
        }
        const user = data.data;
          sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
        sessionStorage.setItem(
            CATEGORY_ID,
            user.currentCategory.categoryId || null
          );
        sessionStorage.setItem(
            'chk',
            JSON.stringify(user.loadStanding) || null
          );
        dispatch(push(home.homePageUrl));
        return dispatch(fetchLoginSuccess({ jwToken, user }));
      });
    }
    function getUserName(jwToken) {
      const userRequestUrl = 'employees/current/';
      apiCall(userRequestUrl)
        .then((response) => {
          const username = response.data;
          sessionStorage.setItem(STAFFID, username);
          return getUserData(jwToken, username);
        })
        .catch(e => dispatch(fetchLoginFailure(e.response.data.message)));
    }
    dispatch(fetchLoginRequest());
    return axios({
      method: 'post',
      url: `${apiUrl}/auth/header`
    })
      .then((response) => {
        const jwToken = response.data;
        sessionStorage.setItem(JWTOKEN, JSON.stringify(jwToken));
        getUserName(jwToken);
      })
      .catch((error) => {
        let errorToDisplay = '';
        if (error.response) {
          errorToDisplay = errors.LOGIN_401;
        } else {
          errorToDisplay = errors.LOGIN_FAILURE;
        }
        dispatch(fetchLoginFailure(errorToDisplay));
      });
  };
}
